import { getApiBaseUrl } from "../../config";
import axios from "../../axios";

export const getReleaseNotesBaseUrl = () => {
  return `${getApiBaseUrl()}release-notes`;
};

export const fetchReleaseNotesMeta = async () => {
  const url = `${getReleaseNotesBaseUrl()}/meta.json?t=${Date.now()}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch release notes meta: ${response.status}`);
  }
  return response.json();
};

export const fetchReleaseNotesContent = async (filename) => {
  const url = `${getReleaseNotesBaseUrl()}/${filename}?t=${Date.now()}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch release notes content: ${response.status}`);
  }
  return response.text();
};

export const saveLastReadVersionToServer = (version) => {
  return axios.put("users/last-read-release-notes-version", { version });
};
